/**
 *
 * ModalCustom
 *
 */

import React, { useState, useEffect } from 'react';
import { Modal, Button } from "antd"
import { Link } from "react-router-dom"
import "./index.less"
import { loadTexts, sanitize,getLanguage } from "../../utils/i18n"
import beta from "images/beta.svg"
import { getLastMeasureOfficialized,updatePdaIaNotification  } from "services/actionPlans"
import pencilIaGreen from "images/pencil-ia-green.svg"
import {
  LOCAL_AMBASSADOR_ID,
  isAmbassadorActive,
  setItem,
  KEY_NEW_PDA_IA_NOTIFICATION
} from "../../utils/storage"
const ModalPdaIaNotification = (props) => {
  const intl = loadTexts("onboarding")
  const { visible, setVisible } = props;
  const [modalMeasureValidate, setModalMeasureValidate] = useState(false);

  
  useEffect(() => {
    const getLastMeasure = async () => {
      
      const measures = await getLastMeasureOfficialized({
        id_ambassador: isAmbassadorActive() ?  LOCAL_AMBASSADOR_ID() :null,
      });
      if (measures.status === 200) {
        
        const measuresData = isAmbassadorActive() ?  (measures.data.data && measures.data.data.result.divisions &&  measures.data.data.result.divisions.length !=0? true : false): (measures.data.data.result ? true : false);
        setModalMeasureValidate(measuresData);
    
      }
    };
  
    getLastMeasure();
  }, []);
  

  return (
    <Modal
      width={754}
      height={458}
      className={ getLanguage() == 'en' ? "PdaIaNotification PdaIaNotification-background-content-en PdaIaNotification-background-footer" : "PdaIaNotification PdaIaNotification-background-content-es PdaIaNotification-background-footer"}
      closable={true}
      visible={visible && modalMeasureValidate}
      onCancel={async () => {
        setVisible(false);
        const updatePdaIa = await updatePdaIaNotification({});
        if(updatePdaIa.status === 201){
          
          setItem(KEY_NEW_PDA_IA_NOTIFICATION, false);
        }
      }}

      footer={<div><Button 
        onClick={async () => {
          setVisible(false);
          setItem(KEY_NEW_PDA_IA_NOTIFICATION, false);

          const updatePdaIa = await updatePdaIaNotification({});
          if(updatePdaIa.status === 201){
            
            setItem(KEY_NEW_PDA_IA_NOTIFICATION, false);
          }
        }} 
        type="primary"
      >
        <Link to={"/action-plans"} style={{fontFamily: "Segoe UI"}}>  
          {intl.pdaIa.button}
        </Link>
      </Button></div>}>
      <div
        className="PdaIaNotification-background-title"
        style={{ color: "#4F4F4F", fontSize: 16 }}>
          <img
          className="PdaIaNotification-background-img"
                          src={pencilIaGreen}
                          style={{
                            marginBottom: 2,
                            display: "inline"
                          }}
                          alt="pencilIaGreen"
                        />
                  
           <b style={{fontWeight: "bolder", fontFamily: "Segoe UI"}}>{intl.pdaIa.title}</b>
        
        <br />
        <span className="PdaIaNotification-background-description">
          {sanitize(intl.pdaIa.description)}</span>
      </div>
    </Modal>

  )
}



export default ModalPdaIaNotification
